import {useMutation, useSuspenseQuery} from "@apollo/client";

import {Card} from "@/components/card/Card.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {
  GQL_ACCOUNT_SAML_SETTINGS_QUERY,
  GQL_REMOVE_ACCOUNT_SAML_SETTINGS,
  GQL_UPDATE_ACCOUNT_SAML_SETTINGS,
} from "@/lib/queries/accounts.ts";
import {AccountSAMLSettingsResult} from "@/lib/types/accounts.ts";
import {GenericMutationResponse, MutationStatusResponse, ResponseStatus} from "@/lib/types/common.ts";
import {SSOSetup} from "@/pages/statuspages/tabs/sso/SSOSetup.tsx";
import {SSOFormValues} from "@/pages/statuspages/tabs/sso/SSOSetupStep2.tsx";

export const SSOSteps = () => {
  const {
    data: {accountSAMLSettings, testIDPs},
  } = useSuspenseQuery<AccountSAMLSettingsResult>(GQL_ACCOUNT_SAML_SETTINGS_QUERY);
  const [updateSAMLSettings] = useMutation<GenericMutationResponse>(GQL_UPDATE_ACCOUNT_SAML_SETTINGS, {
    refetchQueries: [GQL_ACCOUNT_SAML_SETTINGS_QUERY],
  });
  const [removeSAMLSettings] = useMutation<MutationStatusResponse>(GQL_REMOVE_ACCOUNT_SAML_SETTINGS, {
    refetchQueries: [GQL_ACCOUNT_SAML_SETTINGS_QUERY],
  });
  const updateSAML = async (data: SSOFormValues) => {
    const response = await updateSAMLSettings({
      variables: {
        data: data,
      },
    });

    return response.data?.response;
  };
  const removeSAML = async () => {
    const response = await removeSAMLSettings();
    return response.data?.response.status === ResponseStatus.SUCCESS;
  };

  return (
    <Card variant="white" className="mb-4">
      <SSOSetup
        metadataURL={`${URL_ORIGINAL_WEBSITE}/accounts/sso/saml/metadata`}
        samlSettings={accountSAMLSettings}
        testIDPs={testIDPs.items}
        updateSAML={updateSAML}
        removeSAML={removeSAML}
        variant={"general"}
      />
    </Card>
  );
};
